// extracted by mini-css-extract-plugin
export var btnWrap = "style-module--btn-wrap--3efa1";
export var img = "style-module--img--f50f0";
export var learn = "style-module--learn--ac4e7";
export var left = "style-module--left--ff9a3";
export var wrap = "style-module--wrap--a805f";